'use client';
/* eslint-disable */

import {
   Box,
   Button,
   Flex,
   IconButton,
   Table,
   Tbody,
   Td,
   Text,
   Th,
   Thead,
   Tr,
   useColorModeValue,
   useDisclosure,
   Select,
   Grid,
   useOutsideClick,
   useBreakpointValue,
   useColorMode,
} from '@chakra-ui/react';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import React, { useEffect, useState, useRef } from 'react';
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import BankAccountsForm from './BankAccountsForm';
import { useDispatch, useSelector } from 'react-redux';
import { renderFormControl } from '../../../../../utils/DynamicFormData';
import { getBank, deleteBank, getSingleBankBranch, multiDeleteBank } from '../../../../../redux/actions/bank';
import DeleteDialog from '../../components/DeleteDialog';
import { downloadPDF, downloadExcel, useServerPagination } from '../../../../../utils/DataTableUtils';
import ViewSingleData from '../../components/ViewSingleData';
import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import DynamicTable from '../../components/DynamicAllDataTable';
import MobileDataTable from '../../components/MobileDataTable';
import { useGlobal } from '../../../../../contexts';
// filter
import filter from 'assets/img/nfts/filter.svg';
import filter1 from 'assets/img/nfts/filter1.svg';
import nodata from 'assets/img/nfts/no data.svg';
import { GridItem, Input, FormLabel } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';
import { useUser } from 'contexts';
import Loader from 'views/admin/default/Loader';
//filter end

const columnHelper = createColumnHelper();
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

export default function BankAccounts({ columnsData }) {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [sorting, setSorting] = React.useState([]);
   const dispatch = useDispatch();
   const bankData = useSelector((state) => state.bank.list || []);
   const totalCount = useSelector((state) => state.bank.totalCount);
   const pagination = useSelector((state) => state.bank?.pagination);
   const [data, setData] = React.useState([...bankData]);
   const [currentRow, setCurrentRow] = React.useState(null);
   const [searchQuery, setSearchQuery] = React.useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState('');
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false); // State to manage delete confirmation
   const [selectedRowId, setSelectedRowId] = React.useState(null);
   const [isEditMode, setIsEditMode] = React.useState(false);
   const [isOpenSingleView, setIsOpenSingleView] = React.useState(false);
   const singleEntity = useSelector((state) => state?.bank?.single || {});
   const isMobileOrTablet = useBreakpointValue({ base: true, md: false, lg: false });
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const [isEditingPage, setIsEditingPage] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const [pageInputValue, setPageInputValue] = useState('');
   const [currentPage, setCurrentPage] = useState(1);
   const [limit, setLimit] = useState(10);
   const isDesktop = useBreakpointValue({ base: false, md: true });
   const { user } = useUser();
   const Admin = user?.isAdmin;

   const companyId = Number(localStorage.getItem('companyId'));
   const bankRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.bank
      : null;

   const { userGlobalSettingsData } = useGlobal();
   const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.bankBranch;
   const shouldShowCompanyDropdown = globalSetting || false;

   // Use the server pagination hook
   const {
      // handlePageSizeChange,
      // handlePageChange,
      resetPage,
      totalPages,
      // currentPage,
      pageSize,
      getPaginationParams,
   } = useServerPagination(totalCount);

   useEffect(() => {
      setCurrentPage(1); // Reset to page 1 whenever searchQuery changes
   }, [searchQuery]);

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };

   const debouncedSearchHandler = React.useCallback(
      debounce((query) => {
         setDebouncedSearchQuery(query);
      }, 500),
      [],
   );

   // Handle search input changes
   const handleSearchChange = (e) => {
      const value = e.target.value.trimStart();
      setSearchQuery(value);
      debouncedSearchHandler(value);
   };

   useEffect(() => {
      const fetchMainData = async () => {
         try {
            setIsLoading(true);
            await dispatch(
               getBank({
                  page: currentPage,
                  // limit: limit === pagination?.totalProducts ? undefined : limit, // undefined fetches everything
                  search: debouncedSearchQuery,
                  sortBy: sorting.length ? sorting[0]?.name : 'name',
                  sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
                  ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
         } catch (error) {
            console.error('Error fetching main data:', error);
         } finally {
            setIsLoading(false);
         }
      };

      fetchMainData();
   }, [dispatch, currentPage, limit, debouncedSearchQuery, sorting]);

   const handlePageChange = (directionOrPage) => {
      if (typeof directionOrPage === 'number') {
         // Direct page number navigation
         setCurrentPage(directionOrPage);
      } else {
         // Previous/next navigation
         const newPage = directionOrPage === 'next' ? pagination.nextPage : pagination.previousPage;
         if (newPage) setCurrentPage(newPage);
      }
   };

   const handlePageClick = () => {
      setIsEditingPage(true);
      setPageInputValue(''); // Clear input value when starting to edit
   };

   const handlePageInputSubmit = () => {
      const page = parseInt(pageInputValue);
      if (!isNaN(page) && page >= 1 && page <= pagination?.totalPages) {
         handlePageChange(page);
      }
      setIsEditingPage(false);
      setPageInputValue('');
   };

   const handlePageInputBlur = () => {
      handlePageInputSubmit();
   };

   const handlePageKeyDown = (e) => {
      if (e.key === 'Enter') {
         handlePageInputSubmit();
      } else if (e.key === 'Escape') {
         setIsEditingPage(false);
         setPageInputValue('');
      }
   };

   const handlePageSizeChange = (e) => {
      const value = e.target.value;

      // If "ALL" is selected, set limit to null or totalProducts to fetch everything
      const newLimit = value === 'ALL' ? pagination?.totalProducts : Number(value);

      setLimit(newLimit);
      setCurrentPage(1); // Reset to page 1 to avoid offset issues
   };
   const paginatedData = React.useMemo(() => {
      if (limit === pagination?.totalProducts) return bankData;

      if (!Array.isArray(bankData) || bankData.length === 0) {
         return [];
      }
      // const startIndex = (pagination?.currentPage - 1) * limit;
      // const endIndex = startIndex + limit;

      return bankData;
   }, [bankData, pagination?.currentPage, limit, pagination?.totalProducts]);

   // useEffect(() => {
   //   setData([...bankData]);
   // }, [bankData]);

   const handleDelete = async () => {
      if (selectedRowId !== null) {
         try {
            await dispatch(deleteBank(selectedRowId, companyId));
            dispatch(
               getBank({
                  page: currentPage,
                  // limit: limit,
                  search: debouncedSearchQuery,
                  ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
            setData(data.filter((row) => row.id !== selectedRowId));
            setDeleteDialogOpen(false); // Close the dialog after deletion
         } catch (err) {
            // console.error("Failed to delete Color:", err);
         }
      }
   };

   const handleDeleteClick = (id) => {
      setSelectedRowId(id);
      setDeleteDialogOpen(true);
   };

   const handleMutiDeleteClick = async (ids) => {
      if (ids.length > 0) {
         const payload = {
            ids: ids.map(Number),
            compId: user?.loginhistory?.companyId.toString(),
         };
         dispatch(multiDeleteBank(JSON.stringify(payload)));
         setDeleteDialogOpen(false); // Close the dialog after deletion
         await dispatch(
            getBank({
               page: currentPage,
               // limit: limit,
               search: debouncedSearchQuery,
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   };

   const [columnVisibility, setColumnVisibility] = React.useState(
      columnsData.reduce((acc, column) => {
         acc[column.id] = true;
         return acc;
      }, {}),
   );

   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

   const columns = columnsData
      .filter((column) => columnVisibility[column.id])
      ?.map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   const table = useReactTable({
      data,
      columns,
      state: { sorting },
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const handleSave = (formData) => {
      if (isEditMode && currentRow) {
         setData(data?.map((row) => (row.id === currentRow.id ? { ...currentRow, ...formData } : row)));
      } else if (!isEditMode) {
         setData([...data, { ...formData, id: Date.now() }]);
      }
      onClose();
   };

   const filteredData = React.useMemo(() => {
      if (!searchQuery) return data;
      return data?.filter((row) =>
         columnsData?.some((col) => String(row[col.id]).toLowerCase().includes(searchQuery.toLowerCase())),
      );
   }, [data, searchQuery, columnsData]);

   const handleViewSingleData = async (id) => {
      await dispatch(getSingleBankBranch(id));
      setIsOpenSingleView(true);
   };
   var dynamicArray = [];
   dynamicArray = [
      { label: 'Name', value: singleEntity?.name || '-' },
      { label: 'Mobile', value: singleEntity?.mobile || '-' },
      { label: 'Email', value: singleEntity?.email || '-' },
      { label: 'Address', value: singleEntity?.address || '-' },
      { label: 'IFSC Code', value: singleEntity?.ifsc || '-' },
   ];
   // --------------------- filter --------------------- //
   const backgroundColor = useColorModeValue('white', 'rgba(12, 20, 41, 1)');

   const [selectedFilter, setSelectedFilter] = useState(''); // Stores selected filter type
   const [nameselectedFilter, setnameselectedFilter] = useState(''); // Stores input value
   const [ADDRESSselectedFilter, setADDRESSselectedFilter] = useState('');
   const [ACCNOselectedFilter, setACCNOselectedFilter] = useState('');
   const [IFSCCODEselectedFilter, setIFSCCODEselectedFilter] = useState('');
   const [BRANCHselectedFilter, setBRANCHselectedFilter] = useState('');
   const [GSTINselectedFilter, setGSTINselectedFilter] = useState('');
   const [GENERALLEDGERselectedFilter, setGENERALLEDGERselectedFilter] = useState('');
   const [BROKERCODEselectedFilter, setBROKERCODEselectedFilter] = useState('');
   const [TYPEselectedFilter, setTYPEselectedFilter] = useState('');
   const [BALANCEselectedFilter, setBALANCEselectedFilter] = useState('');

   const [inputValue, setInputValue] = useState('');
   const [nameinputvalue, setnameinputvalue] = useState(''); // Stores input value
   const [ADDRESSInputValue, setADDRESSInputValue] = useState('');
   const [ACCNOInputValue, setACCNOInputValue] = useState('');
   const [IFSCCODEInputValue, setIFSCCODEInputValue] = useState('');
   const [BRANCHInputValue, setBRANCHInputValue] = useState('');
   const [GSTINInputValue, setGSTINInputValue] = useState('');
   const [GENERALLEDGERInputValue, setGENERALLEDGERInputValue] = useState('');
   const [BROKERCODEinputValue, setBROKERCODEInputValue] = useState('');
   const [TYPEInputValue, setTYPEInputValue] = useState('');
   const [BALANCEInputValue, setBALANCEInputValue] = useState('');
   const [addedName, setAddedName] = useState(''); // Stores final displayed value

   const [BankData, setBankData] = useState([]);

   useEffect(() => {
      const fetchData = async () => {
         try {
            // const fetchParams = selectedFilter === "option11" ? { type: 'K', name: nameinputvalue } : { type: 'K' };

            let fetchParams = {
               page: currentPage,
               // limit: limit === pagination?.totalProducts ? undefined : limit,
               search: debouncedSearchQuery,
               sortBy: sorting.length ? sorting[0]?.name : 'name',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            };
            let filters = [];

            if (nameinputvalue && nameselectedFilter) {
               filters.push({ name: 'bb.name', value: nameinputvalue, type: nameselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (ADDRESSInputValue && ADDRESSselectedFilter) {
               filters.push({ name: 'bb.address', value: ADDRESSInputValue, type: ADDRESSselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (ACCNOInputValue && ACCNOselectedFilter) {
               filters.push({ accountNumber: { value: ACCNOInputValue, type: ACCNOselectedFilter } });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (IFSCCODEInputValue && IFSCCODEselectedFilter) {
               filters.push({ name: 'bb.ifsc', value: IFSCCODEInputValue, type: IFSCCODEselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (BRANCHInputValue && BRANCHselectedFilter) {
               filters.push({ branch: { value: BRANCHInputValue, type: BRANCHselectedFilter } });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (GSTINInputValue && GSTINselectedFilter) {
               filters.push({ gstIn: { value: GSTINInputValue, type: GSTINselectedFilter } });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (GENERALLEDGERInputValue && GENERALLEDGERselectedFilter) {
               filters.push({ generalLedger: { value: GENERALLEDGERInputValue, type: GENERALLEDGERselectedFilter } });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (BROKERCODEinputValue && BROKERCODEselectedFilter) {
               filters.push({ brokerCode: { value: BROKERCODEinputValue, type: BROKERCODEselectedFilter } });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (TYPEInputValue && TYPEselectedFilter) {
               filters.push({ type: { value: TYPEInputValue, type: TYPEselectedFilter } });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (BALANCEInputValue && BALANCEselectedFilter) {
               filters.push({ balance: { value: BALANCEInputValue, type: BALANCEselectedFilter } });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            const response = await dispatch(getBank(fetchParams));

            // Check if response is an array
            if (response?.length > 0 && Array.isArray(response)) {
               setBankData(response);
            } else {
               console.warn('No data found. Setting empty array.');
               // setnameinputvalue("");
               setBankData([]); // ✅ Prevents 'undefined' error
            }
         } catch (error) {
            console.error('Error fetching data:', error);
            setBankData([]); // ✅ Ensure an empty array is set
         }
      };
      fetchData();
   }, [
      dispatch,
      nameinputvalue,
      ADDRESSInputValue,
      ACCNOInputValue,
      IFSCCODEInputValue,
      BRANCHInputValue,
      GSTINInputValue,
      GENERALLEDGERInputValue,
      BROKERCODEinputValue,
      TYPEInputValue,
      BALANCEInputValue,
   ]);

   useEffect(() => {
      setData([...bankData]);
   }, [bankData]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (e.key.toLowerCase() === 'n' || e.key === '+') {
            if (!isOpen && !isOpenSingleView && (Admin || bankRight?.add)) {
               e.preventDefault();
               setCurrentRow({});
               setIsEditMode(false);
               onOpen();
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [!isOpen, !isOpenSingleView, Admin, bankRight?.add]);

   const [isDropdownOpen, setDropdownOpen] = useState(false);

   const toggleDropdown = () => {
      setDropdownOpen(!isDropdownOpen);
   };

   const [selectedColumn, setSelectedColumn] = useState(null);

   const handleImageClick = (columnHeader) => {
      setSelectedColumn(columnHeader); // Store which column was clicked
      setDropdownOpen(true);
      if (selectedColumn?.props?.children === 'NAME') {
         setInputValue(nameinputvalue);
      } else if (selectedColumn?.props?.children === 'ADDRESS') {
         setInputValue(ADDRESSInputValue);
      } else if (selectedColumn?.props?.children === 'ACC NO') {
         setInputValue(ACCNOInputValue);
      } else if (selectedColumn?.props?.children === 'IFSC Code') {
         setInputValue(IFSCCODEInputValue);
      } else if (selectedColumn?.props?.children === 'BRANCH') {
         setInputValue(BRANCHInputValue);
      } else if (selectedColumn?.props?.children === 'GSTIN') {
         setInputValue(GSTINInputValue);
      } else if (selectedColumn?.props?.children === 'GENERAL LEDGER') {
         setInputValue(GENERALLEDGERInputValue);
      } else if (selectedColumn?.props?.children === 'BROKER CODE') {
         setInputValue(BROKERCODEinputValue);
      } else if (selectedColumn?.props?.children === 'TYPE') {
         setInputValue(TYPEInputValue);
      } else if (selectedColumn?.props?.children === 'BALANCE') {
         setInputValue(BALANCEInputValue);
      }
      // setIsModalOpen(true); // Open modal
   };

   const handleFilterClick = () => {
      const selectedKey = selectedColumn?.props?.children;
      const inputSetters = {
         NAME: setnameinputvalue,
         ADDRESS: setADDRESSInputValue,
         'ACC NO': setACCNOInputValue,
         'IFSC CODE': setIFSCCODEInputValue,
         BRANCH: setBRANCHInputValue,
         GSTIN: setGSTINInputValue,
         'GENERAL LEDGER': setGENERALLEDGERInputValue,
         'BROKER CODE': setBROKERCODEInputValue,
         TYPE: setTYPEInputValue,
         BALANCE: setBALANCEInputValue,
      };

      const selectedoption = {
         NAME: setnameselectedFilter,
         ADDRESS: setADDRESSselectedFilter,
         'ACC NO': setACCNOselectedFilter,
         'IFSC CODE': setIFSCCODEselectedFilter,
         BRANCH: setBALANCEselectedFilter,
         GSTIN: setGSTINselectedFilter,
         'GENERAL LEDGER': setGENERALLEDGERselectedFilter,
         'BROKER CODE': setBROKERCODEselectedFilter,
         TYPE: setTYPEselectedFilter,
         BALANCE: setBALANCEselectedFilter,
      };

      if (selectedKey && inputSetters[selectedKey]) {
         inputSetters[selectedKey](inputValue); // Assign value only on button click
      }

      if (selectedKey && selectedoption[selectedKey]) {
         selectedoption[selectedKey](selectedFilter); // Assign value only on button click
      }

      setDropdownOpen(false);
   };

   const handlecancelClick = () => {
      if (selectedColumn?.props?.children === 'NAME') {
         setnameinputvalue('');
      } else if (selectedColumn?.props?.children === 'ADDRESS') {
         setADDRESSInputValue('');
      } else if (selectedColumn?.props?.children === 'ACC NO') {
         setACCNOInputValue('');
      } else if (selectedColumn?.props?.children === 'IFSC CODE') {
         setIFSCCODEInputValue('');
      } else if (selectedColumn?.props?.children === 'BRANCH') {
         setBRANCHInputValue('');
      } else if (selectedColumn?.props?.children === 'GSTIN') {
         setGSTINInputValue('');
      } else if (selectedColumn?.props?.children === 'GENERAL LEDGER') {
         setGENERALLEDGERInputValue('');
      } else if (selectedColumn?.props?.children === 'BROKER CODE') {
         setBROKERCODEInputValue('');
      } else if (selectedColumn?.props?.children === 'TYPE') {
         setTYPEInputValue('');
      } else if (selectedColumn?.props?.children === 'BALANCE') {
         setBALANCEInputValue('');
      }
      setSelectedFilter('');
      setDropdownOpen(false);
   };

   const getLeftValue = (column) => {
      switch (column) {
         case 'NAME':
         case 'ADDRESS':
         case 'ACC NO':
            return '3%';
         case 'IFSC CODE':
         case 'BRANCH':
         case 'GSTIN':
            return '30%';
         case 'GENERAL LEDGER':
         case 'BROKER CODE':
         case 'TYPE':
            return '60%';
         default:
            return '70%';
      }
   };
   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   return (
      <>
         <Box bg={backgroundColor} w={'100%'} borderRadius="xl" border="1px solid #e2e8f0">
            <Flex
               width={{ base: '100%', md: 'auto' }}
               mb={1}
               px={{ base: '1px', md: '25px' }}
               justifyContent="space-between"
               align="center"
               overflowX="auto"
               flexWrap="nowrap"
               gap={3}>
               {/* Left Section: Title + Add New Button */}
               <Flex align="center" gap={4} flexShrink={0}>
                  <Text
                     color={textColor}
                     ml={{ base: '8px', md: 0 }}
                     fontSize={{ base: '17px', lg: '22px' }}
                     fontWeight="700"
                     lineHeight="100%">
                     Bank Branch
                  </Text>
               </Flex>

               {/* Right Section: Pagination + Limit + Search + Menu */}
               <Flex align="center" gap={2} flexShrink={0} p={3}>
                  {!isMobileOrTablet && (Admin || bankRight?.add) && user && !user.isExpired && (
                     <button
                        onClick={() => {
                           setCurrentRow({});
                           setIsEditMode(false);
                           onOpen();
                        }}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${isDark
                           ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                           : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                           }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${isDark ? 'via-cyan-100/20' : 'via-white/30'
                              }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${isDark
                              ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                              : 'bg-white/20 group-hover:bg-white/30'
                              }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  )}
                  {/* Search Field */}
                  <MotionFlex
                     ref={wrapperRef}
                     align="center"
                     bg={bg}
                     borderRadius="full"
                     cursor="pointer"
                     px={expanded ? 3 : 0}
                     w={expanded ? '200px' : '40px'}
                     h="40px"
                     transition="all 0.3s ease"
                     onClick={() => setExpanded(true)}>
                     <MotionSearchIcon
                        color={icon}
                        animate={{ rotate: expanded ? 0 : 90 }}
                        transition={{ duration: 0.3 }}
                        style={{
                           marginRight: expanded ? '8px' : '10px',
                           marginLeft: expanded ? '0' : '10px',
                        }}
                     />
                     {expanded && (
                        <Input
                           variant="unstyled"
                           placeholder="Search..."
                           value={searchQuery}
                           color={icon}
                           // onChange={(e) => setSearchQuery(e.target.value)}
                           onChange={handleSearchChange}
                           autoFocus
                        />
                     )}
                  </MotionFlex>
               </Flex>

               {/* Mobile Floating Add New Button */}
               {isMobileOrTablet && (Admin || bankRight?.add) && user && !user.isExpired && (
                  <Box position="fixed" bottom="4" right="4" zIndex={999}>
                     <button
                        onClick={() => {
                           setCurrentRow({});
                           setIsEditMode(false);
                           onOpen();
                        }}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${isDark
                           ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                           : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                           }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${isDark ? 'via-cyan-100/20' : 'via-white/30'
                              }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${isDark
                              ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                              : 'bg-white/20 group-hover:bg-white/30'
                              }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  </Box>
               )}
            </Flex>

            {/* Table Rendering */}
            <div className="px-4 pb-4">
               {isLoading ? (
                  <Loader />
               ) : (
                  <DynamicTable
                     right={bankRight}
                     table={table}
                     data={paginatedData}
                     handleViewSingleData={handleViewSingleData}
                     handleImageClick={handleImageClick}
                     toggleDropdown={toggleDropdown}
                     filter={filter}
                     emptyMessage="No bank accounts data found"
                     onEditClick={(row) => {
                        setCurrentRow(row);
                        setIsEditMode(true);
                        onOpen();
                        setIsOpenSingleView(false);
                     }}
                     onDeleteClick={(id) => {
                        handleDeleteClick(id);
                        setIsOpenSingleView(false);
                     }}
                     onMultiDeleteClick={(ids) => {
                        handleMutiDeleteClick(ids);
                     }}
                     canDelete={true}
                     columnVisibility={columnVisibility}
                     columnsData={columnsData}
                     sorting={sorting}
                     limit={limit}
                     setCurrentRow={setCurrentRow}
                     onOpen={onOpen}
                     setIsEditMode={setIsEditMode}
                     setIsOpenSingleView={setIsOpenSingleView}
                     setDeleteDialogOpen={setDeleteDialogOpen}
                     setSelectedRowId={setSelectedRowId}
                     debouncedSearchQuery={debouncedSearchQuery}
                     totalCount={totalCount}
                     entityType={'bank'}
                  />
               )}
            </div>
            <BankAccountsForm
               isOpen={isOpen}
               onClose={onClose}
               isEditMode={isEditMode}
               currentRow={currentRow}
               onSave={handleSave}
            />

            <style jsx>{`
               .editable-row {
                  position: relative;
                  background: ${useColorModeValue('white', 'gray.700')};
                  transition: background 0.3s ease;
               }

               .editable-row:hover {
                  background: ${useColorModeValue('gray.100', 'gray.600')};
               }

               .editable-row .edit-icon-container {
                  display: none;
               }

               .editable-row:hover .edit-icon-container {
                  display: block;
                  position: absolute;
                  right: 10px;
                  top: 50%;
                  transform: translateY(-50%);
               }
            `}</style>
            <DeleteDialog
               isDeleteDialogOpen={isDeleteDialogOpen}
               setDeleteDialogOpen={setDeleteDialogOpen}
               handleDelete={handleDelete}
               title="Bank Branch"
            />
         </Box>
         {isDropdownOpen && selectedColumn?.props?.children && (
            <Box
               position="absolute"
               top="300px" // Dropdown below image
               left={getLeftValue(selectedColumn?.props?.children)}
               width="auto"
               bg={backgroundColor}
               border="1px solid gray"
               borderRadius="5px"
               boxShadow="md"
               p="2"
               mt="2"
               zIndex="10"
               transition="all 0.2s ease-in-out">
               <Grid templateColumns="repeat(1, 1fr)" gap={4} p={4}>
                  <Grid justifyContent="center" color={textColor} fontSize="2xl" fontWeight="medium">
                     <label>Select {selectedColumn.props.children.toLowerCase()} Filter</label>
                  </Grid>
                  <hr></hr>
                  {/* Label and Dropdown */}
                  {['CREATED DATE', 'BALANCE', 'GST PERCENTAGE', 'HSN', 'ORDINAL', 'ACCOUNT NO'].includes(
                     selectedColumn?.props?.children,
                  ) ? (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="dropdown" width="60%" color={textColor}>
                           Select option
                        </FormLabel>
                        <Select
                           id="dropdown"
                           placeholder="Choose an option"
                           color={textColor}
                           onChange={(e) => setcreateddateselectedFilter(e.target.value)} // Update selected filter
                        >
                           <option value="equal">Equal (=)</option>
                           <option value="less_than">Less than (&lt;)</option>
                           <option value="less_than_equal">Less than or equal (&le;)</option>
                           <option value="greater_than">Greater than (&gt;)</option>
                           <option value="greater_than_equal">Greater than or equal (&le;)</option>
                        </Select>
                     </GridItem>
                  ) : (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="dropdown" width="60%" color={textColor}>
                           Select option
                        </FormLabel>
                        <Select
                           id="dropdown"
                           placeholder="Choose an option"
                           color={textColor}
                           onChange={(e) => setSelectedFilter(e.target.value)} // Update selected filter
                        >
                           <option value="1">Starts With</option>
                           <option value="2">Ends With</option>
                           <option value="3">Contains</option>
                           <option value="4">Equal</option>
                           <option value="5">Empty</option>
                           <option value="6">Does Not Start With</option>
                           <option value="7">Does Not End With</option>
                           <option value="8">Does Not Contain</option>
                           <option value="9">Not Equal</option>
                           <option value="10">Not Empty</option>
                           <option value="11">Like</option>
                        </Select>
                     </GridItem>
                  )}

                  {/* Second Label and Input Box */}
                  <GridItem display="flex" alignItems="center">
                     <FormLabel htmlFor="input1" width="60%" color={textColor}>
                        Enter the value
                     </FormLabel>
                     <Input
                        id="input2"
                        color={textColor}
                        placeholder="Enter last name"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                     />
                  </GridItem>

                  {/* Button */}
                  <GridItem mt="20px" display="flex" justifyContent="space-between">
                     <Button colorScheme="blue" width="45%" onClick={handleFilterClick}>
                        Filter
                     </Button>
                     <Button colorScheme="red" width="45%" onClick={handlecancelClick}>
                        cancel
                     </Button>
                  </GridItem>
               </Grid>
            </Box>
         )}
      </>
   );
}
